import * as React from 'react';
import { tag } from '../../../../model/tag';
import { StyledComponentProps, Typography, Grid, Divider } from '@material-ui/core';
import { useState } from 'react';
import { contact } from '../../../../model/contact';
import { SortIcon } from './sortIcon';
import { WithMediaQuery, IMediaQueryProps } from '../../../../layout/withMediaQuery';

interface IProps extends StyledComponentProps, IMediaQueryProps {
    tag: tag;
    classes: any;
}

const getBirthDate = (c: contact): string => {
    if (c.birthDate && c.birthDate.getDate)
        return c.birthDate.toLocaleDateString()
    else if (c.birthDate)
        return new Date(c.birthDate).toLocaleDateString()
    else
        return ' - '
}

const Row = (classes, c: contact, n, smallScreen: boolean) => (
    <>
        {!smallScreen && <Grid item sm={1} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{n}</Typography>
        </Grid>}
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{c.surname? `${c.surname} ${c.name}` : c.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}></Typography>
        </Grid>
        <Grid item xs={12} sm={3} className={classes.tableCell}>
            <Typography variant='body2' className={classes.detailCellText}>{getBirthDate(c)}</Typography>
        </Grid>
        <Divider style={{ width: '100%' }} />
    </>)

const TableComp = (props: IProps) => {
    const [sortAttribute, setSortAttribute] = useState('');
    const [sort, setSort] = useState('');
    const sortColumn = (col: string) => {
        const direction = sortAttribute === col ? sort === 'up' ? 'down' : 'up' : 'down';
        setSort(direction);
        setSortAttribute(col);
    }
    const sortData = (followers: contact[]) => {
        followers.sort((c1, c2) => {
            const _1 = c1[sortAttribute] ? c1[sortAttribute].toLowerCase() : '';
            const _2 = c2[sortAttribute] ? c2[sortAttribute].toLowerCase() : '';
            var res = _1 < _2 ? -1 : 1;
            if (sort === 'up')
                res = res * -1;
            return res;
        })
        return followers;
    }
    const { classes, tag } = props;
    return (
        <>
            {!props.smallScreen && <Grid container className={classes.tableHeader}>
                <Grid item sm={1} className={props.classes.tableHeaderCell}>
                    <Typography className={classes.detailHeaderText}>N.</Typography>
                </Grid>
                <Grid item sm={4} className={props.classes.tableHeaderCell}>
                    <Typography className={classes.detailHeaderText}>Cognome e Nome / Email</Typography>
                    <SortIcon sort={sortAttribute === 'surname' ? sort : ''} onClick={() => sortColumn('surname')} />
                </Grid>
                <Grid item sm={4} className={props.classes.tableHeaderCell}>
                    <Typography className={classes.detailHeaderText}>Residenza</Typography>
                    <SortIcon sort={sortAttribute === 'place' ? sort : ''} onClick={() => sortColumn('place')} />
                </Grid>
                <Grid item sm={3} className={props.classes.tableHeaderCell}>
                    <Typography className={classes.detailHeaderText}>Data nascita</Typography>
                    <SortIcon sort={sortAttribute === 'birthDate' ? sort : ''} onClick={() => sortColumn('birthDate')} />
                </Grid>
            </Grid>}
            <Grid container className={classes.table}>
                {tag.followers && sortData(tag.followers).map((f, idx) => { return Row(classes, f, idx, props.smallScreen) })}
            </Grid>
        </>
    );
}

export const Table = WithMediaQuery(TableComp);